import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

import Home from '../views/Home.vue'
import CompanyDashboard from '@vue-app/views/company/CompanyDashboard.vue'
import Profile from '../views/user/Profile.vue'
import CompanyAnalytics from '@vue-app/views/company/CompanyAnalytics.vue'
import CompanyBills from '@vue-app/views/company/CompanyBills.vue'
import BillsCreateType from '@vue-app/views/company/Bills/BillsCreateType.vue'
import CreateBill from '@vue-app/views/company/Bills/CreateBill.vue'
import BillView from '@vue-app/views/company/Bills/BillView.vue'
import BillTemplates from '@vue-app/views/company/Bills/BillTemplates.vue'
import EditBillTemplate from '@vue-app/views/company/Bills/EditBillTemplate.vue'
import RefundBill from '@vue-app/views/company/Bills/RefundBill.vue'
import CreateBillTemplate from '@vue-app/views/company/Bills/CreateBillTemplate.vue'
import BillTemplateView from '@vue-app/views/company/Bills/BillTemplateView.vue'
import CompanyPayouts from '@vue-app/views/company/CompanyPayouts.vue'
import CreatePayoutToCard from '@vue-app/views/company/Payouts/CreatePayoutToCard.vue'
import PayoutToCardView from '@vue-app/views/company/Payouts/PayoutToCardView.vue'
import CompanyTechSupport from '@vue-app/views/company/CompanyTechSupport.vue'
import ChangePassword from '@vue-app/views/user/ChangePassword.vue'
import RefundOperation from '@vue-app/views/company/Operations/RefundOperation.vue'
import SettingsBase from '@vue-app/views/company/Settings/SettingsBase.vue'
import SettingsUsers from '@vue-app/views/company/Settings/SubPages/SettingsUsers.vue'
import SettingsUserCreate from '@vue-app/views/company/Settings/SubPages/SettingsUserCreate.vue'
import SettingsUserEdit from '@vue-app/views/company/Settings/SubPages/SettingsUserEdit.vue'
import { companyMiddleware } from '@vue-app/router/middleware/company.middleware'
import EnterPhone from '@vue-app/views/auth/set-password/EnterPhone.vue'
import EnterCode from '@vue-app/views/auth/set-password/EnterCode.vue'
import SetPassword from '@vue-app/views/auth/set-password/SetPassword.vue'
import SetPasswordSuccessful from '@vue-app/views/auth/set-password/SetPasswordSuccessful.vue'
import ForgotPassword from '@vue-app/views/auth/ForgotPassword.vue'
import UploadBillRegistry from '@vue-app/views/company/Bills/UploadBillRegistry.vue'
import UploadPayoutsRegistry from '@vue-app/views/company/Payouts/UploadPayoutsRegistry.vue'
import PayoutsRegistry from '@vue-app/views/company/Payouts/ByRegistry/PayoutsRegistry.vue'
import BillsRegistry from '@vue-app/views/company/Bills/ByRegistry/BillsRegistry.vue'
import CenterSupport from '@vue-app/views/centerSupport/CenterSupport.vue'
import Login from '@vue-app/views/auth/Login.vue'
import LoginOtp from '@vue-app/views/auth/LoginOtp.vue'
import LoginOtpError from '@vue-app/views/auth/LoginOtpError.vue';
import { PASSWORD_FLOW } from './constants'
import CompanyInvoicesModule from '@vue-app/views/company/CompanyInvoicesModule.vue';

import authorizer from '@js-app/services/helpers/authorizer-instance'

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true,
    meta: { layout: 'auth-layout' },
  },
  {
    path: '/login/two-factor-authentication',
    name: 'login-otp',
    component: LoginOtp,
    props: true,
    meta: { layout: 'auth-layout' },
  },
  {
   path: '/login/otp-error',
    name: 'login-otp-error',
    component: LoginOtpError,
    props: true,
    meta: {  layout: 'auth-layout' },
  },
  {
    path: '/cabinet',
    name: 'cabinet',
    component: Home,
    meta: { layout: 'home-layout' },
  },
  {
    path: '/cabinet/company/:id/center-support',
    component: CenterSupport,
    meta: { layout: 'company-layout' },
    name: 'center-support',
    props: true,
  },
  {
    path: '/cabinet/profile',
    component: Profile,
    meta: {
      layout: 'home-layout',
      bgColor: '#ffffff',
      bgColorDesktop: null,
    },
  },
  {
    path: '/cabinet/profile/change-password',
    component: ChangePassword,
    meta: {
      layout: 'home-layout',
      bgColor: '#ffffff',
      bgColorDesktop: null,
    },
  },
  {
    path: '/cabinet/company/:id',
    name: 'company-dashboard',
    component: CompanyDashboard,
    meta: { layout: 'company-layout' },
    props: true,
  },
  {
    path: '/cabinet/company/:id/analytics',
    component: CompanyAnalytics,
    meta: { layout: 'company-layout' },
    name: 'company-analytics',
    props: true,
  },
  {
    path: '/cabinet/company/:id/invoices',
    component: CompanyInvoicesModule,
    meta: {
      layout: 'company-layout',
      // accessControl: { action: 'read', data: 'bills-list' },
    },
    name: 'company-invoices',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills',
    component: CompanyBills,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'bills-list' },
    },
    name: 'company-bills',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/create',
    component: BillsCreateType,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'bills-make' },
    },
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/create/base',
    component: CreateBill,
    meta: { layout: 'company-layout' },
    name: 'company-bills-create',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/templates',
    component: BillTemplates,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'bills-template-view' },
    },
    name: 'company-bills-templates',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/templates/create',
    component: CreateBillTemplate,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'bills-template-make_template' },
    },
    name: 'company-bills-templates-create',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/templates/:templateId',
    component: BillTemplateView,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'bills-template-make_bills' },
    },
    name: 'company-bills-template-view',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/templates/:templateId/edit',
    component: EditBillTemplate,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'bills-template-make_template' },
    },
    name: 'company-bills-template-edit',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/:billId',
    component: BillView,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'bills-list' },
    },
    name: 'company-bill-view',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/:billId/refund',
    component: RefundBill,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'bills-refund' },
    },
    name: 'company-bill-refund',
    props: true,
  },
  {
    path: '/cabinet/company/:id/payouts',
    component: CompanyPayouts,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'payout-to-card-list' },
    },
    name: 'company-payouts',
    props: true,
  },
  {
    path: '/cabinet/company/:id/payouts/to-card/create',
    component: CreatePayoutToCard,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'payout-to-card-make_payout' },
    },
    name: 'company-payouts-to-card-create',
    props: true,
  },
  {
    path: '/cabinet/company/:id/payouts/to-card/:payoutId',
    component: PayoutToCardView,
    meta: {
      layout: 'company-layout',
      accessControl: { action: 'read', data: 'payout-to-card-list' },
    },
    name: 'company-payouts-to-card-view',
    props: true,
  },
  {
    path: '/cabinet/company/:id/payouts/by-registry/create',
    component: UploadPayoutsRegistry,
    meta: { layout: 'company-layout' },
    name: 'company-payouts-by-registry-create',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bill/by-registry/create',
    name: 'bill-registries-create',
    component: UploadBillRegistry,
    meta: { layout: 'company-layout' },
    props: true,
  },
  {
    path: '/cabinet/company/:id/payouts/by-registry/:payoutsRegistryId',
    component: PayoutsRegistry,
    meta: { layout: 'company-layout' },
    name: 'payouts-registry',
    props: true,
  },
  {
    path: '/cabinet/company/:id/bills/by-registry/:billsRegistryId',
    component: BillsRegistry,
    meta: { layout: 'company-layout' },
    name: 'bills-registry',
    props: true,
  },
  {
    path: '/cabinet/company/:id/support',
    component: CompanyTechSupport,
    meta: { layout: 'company-layout' },
    name: 'company-support',
    props: true,
  },
  {
    path: '/cabinet/company/:id/operations/:operationId/refund',
    component: RefundOperation,
    name: 'refund-operation',
    meta: {
      accessControl: { action: 'read', data: 'analitics-refund' },
      layout: 'company-layout',
    },
    props: true,
  },
  {
    path: '/cabinet/company/:id/settings',
    component: SettingsBase,
    children: [
      {
        path: '',
        redirect: { name: 'settings-users' }
      },
      {
        path: 'users',
        name: 'settings-users',
        component: SettingsUsers,
        meta: {
          accessControl: { action: 'read', data: 'settings-users-list' },
          layout: 'company-layout',
        },
      },
      {
        path: 'users/create',
        component: SettingsUserCreate,
        name: 'create-company-user',
        meta: {
          accessControl: { action: 'read', data: 'settings-users-create' },
          layout: 'company-layout',
        },
      },
      {
        path: 'users/:userId/edit',
        component: SettingsUserEdit,
        name: 'edit-company-user',
        meta: {
          accessControl: { action: 'read', data: 'settings-users-edit' },
          layout: 'company-layout',
        },
        props: true,
      },
    ],
    meta: { layout: 'company-layout' },
    props: true,
  },
  // AUTH (INVITE/RESET/FORGOT)
  {
    path: '/auth/invite/:hash',
    component: EnterPhone,
    name: 'invite-phone',
    meta: { setPasswordType: PASSWORD_FLOW.INVITE, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/invite/:hash/otp',
    name: 'invite-otp',
    component: EnterCode,
    meta: { setPasswordType: PASSWORD_FLOW.INVITE, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/invite/:hash/password',
    name: 'invite-password',
    component: SetPassword,
    meta: { setPasswordType: PASSWORD_FLOW.INVITE, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/invite/:hash/success',
    name: 'invite-success',
    component: SetPasswordSuccessful,
    meta: { setPasswordType: PASSWORD_FLOW.INVITE, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/reset-password/:hash',
    component: EnterPhone,
    name: 'reset-password-phone',
    meta: { setPasswordType: PASSWORD_FLOW.RESET, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/reset-password/:hash/otp',
    name: 'reset-password-otp',
    component: EnterCode,
    meta: { setPasswordType: PASSWORD_FLOW.RESET, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/reset-password/:hash/password',
    name: 'reset-password-password',
    component: SetPassword,
    meta: { setPasswordType: PASSWORD_FLOW.RESET, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/reset-password/:hash/success',
    name: 'reset-password-success',
    component: SetPasswordSuccessful,
    meta: { setPasswordType: PASSWORD_FLOW.RESET, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/forgot-password/:hash',
    component: EnterPhone,
    name: 'forgot-password-phone',
    meta: { setPasswordType: PASSWORD_FLOW.FORGOT, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/forgot-password/:hash/otp',
    name: 'forgot-password-otp',
    component: EnterCode,
    meta: { setPasswordType: PASSWORD_FLOW.FORGOT, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/forgot-password/:hash/password',
    name: 'forgot-password-password',
    component: SetPassword,
    meta: { setPasswordType: PASSWORD_FLOW.FORGOT, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/forgot-password/:hash/success',
    name: 'forgot-password-success',
    component: SetPasswordSuccessful,
    meta: { setPasswordType: PASSWORD_FLOW.FORGOT, layout: 'auth-layout' },
    props: true,
  },
  {
    path: '/auth/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: { setPasswordType: PASSWORD_FLOW.FORGOT, layout: 'auth-layout' },
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active-exact'
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.path.startsWith('/cabinet'));
  const isAuthenticated = store.getters.isUserLoggedIn;

  if (requiresAuth && !isAuthenticated) {
    console.log("redirect to login");
    return next({
      path: '/login',
    });
  }

  if ((to.path === '/login' || to.path.startsWith('/auth/')) && isAuthenticated) {
    return next({ name: 'cabinet' });
  }

  await companyMiddleware({ to, store })

  const acl = to.meta.accessControl
  if (acl && acl.action && acl.data) {
    const userId = store.getters.userData.UserID.toString()
    const isAllowed = await authorizer.can(acl.action, acl.data, userId)
    if (isAllowed) {
      return next()
    } else {
      return next({ name: 'company-dashboard', params: { id: to.params.id } })
    }
  }

  next()
})

export default router
